export default __webpack_public_path__ + "static/media/doc_posterios_val.46926990.svg";